{
  "Purchase": "CompletePayment",
  "Complete Order Tapped": "PlaceAnOrder",
  "Homepage Main CTA Tapped": "ClickButton",
  "Checkout Sheet Opened": "InitiateCheckout",
  "Web Email Capture Screen Filled": "CompleteRegistration",
  "Add to Cart Tapped": "AddToCart",
  "Classic Add to Cart": "AddToCart",
  "Photo Picked": "AddToCart"
}